<div class="_app-container">
  <div class="_loading-indicator">
    <p-progress-spinner></p-progress-spinner>
  </div>
  <div class="_router-outlet-container">
    <router-outlet></router-outlet>
  </div>
</div>
<p-confirmdialog></p-confirmdialog>
